jQuery(document).ready(function ($) {
  const $menuIcon = $('.mobile-menu-icon');
  const $menuLines = $menuIcon.find('.line');
  const $header = $('header');
  const $menuWrapper = $('.menu-wrapper'); // this wraps #nav-menu
  const $navMenu = $('#nav-menu');

  $menuIcon.on('click', function () {
    const isActive = $navMenu.hasClass('active');

    if (isActive) {
      $menuWrapper.fadeOut(300, () => {
        $navMenu.removeClass('active');
      });
    } else {
      $menuWrapper.fadeIn(300, () => {
        $navMenu.addClass('active');
      });
    }

    // Toggle menu icon lines
    $menuIcon.toggleClass('active');
    $menuLines.each(function () {
      $(this).toggleClass('active');
    });

    // Toggle header class (without fade)
    $header.toggleClass('active');

    // Optional: aria-expanded for accessibility
    const isExpanded = $menuIcon.attr('aria-expanded') === 'true';
    $menuIcon.attr('aria-expanded', !isExpanded);
  });

  // Close menu when nav link is clicked (mobile only)
  $('#nav-menu a').on('click', function () {
    if ($navMenu.hasClass('active')) {
      $menuWrapper.fadeOut(300, () => {
        $navMenu.removeClass('active');
        $menuIcon.removeClass('active');
        $menuLines.removeClass('active');
        $header.removeClass('active');
        $menuIcon.attr('aria-expanded', 'false');
      });
    }
  });


  // FORM LOGIC

  $("#umi-newsletter-code").on("submit", function (e) {
    // Prevent default browser actions on form submission.
    e.preventDefault();
    // Get all the form user submitted data and get it ready to be sent.
    var data = $(this).serialize();
    // POST all the data to the SMF submission endpoint URL.
    $.ajax({
      type: "POST",
      url: "https://subs.sonymusicfans.com/submit",
      dataType: "json",
      data: data,
      xhrFields: {
        withCredentials: false
      },
      success: function (data) {
        // Do things on successful submission.
        alert("Submitted!");
      },
      error: function (err) {
        // Do things when submission has an error.
        alert("An error has occured!");
      }
    });
  });

  $('body').on('change', '.mailing-list-id', function () {
    $("#ts-for-" + $(this).attr('id')).prop("checked", $(this).is(':checked'));
  });
});
